import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

export default function DiscreteSliderLabel ({ min = 1, max = 100, marks = [], handleChange = (e: any) => { }, defaultVal = 1 }) {
  return (
    <Box sx={{ width: 300 }}>
      <Slider
        aria-label="Always visible"
        min={min}
        max={max}
        defaultValue={defaultVal}
        step={1}
        marks={marks}
        onChange={(e: any) => {
          handleChange(e?.target?.value)
        }}
        sx={{
          "& .MuiSlider-markLabel": {
            fontSize: "9px",
          },
        }}
      />
    </Box>
  );
}